export const initialPolygons = [
  [
    [
      121.1276618022858, 14.295180418203639
    ],
    [
      121.1276743247984, 14.294892133277422
    ],
    [
      121.12773067491094, 14.294541177985321
    ],
    [
      121.12780580807585, 14.294215290313623
    ],
    [
      121.12805624965716, 14.294318756985167
    ],
    [
      121.12791654697952, 14.295105335513467
    ],
    [
      121.12800386165267, 14.295664680378062
    ],
    [
      121.12831819367659, 14.29606670927028
    ],
    [
      121.1285452123597, 14.296363861292106
    ],
    [
      121.129331044418, 14.296643533391007
    ],
    [
      121.12969776577873, 14.29699312384803
    ],
    [
      121.13006448713946, 14.297639866326879
    ],
    [
      121.13043120983252, 14.297989456783903
    ],
    [
      121.13052159042081, 14.297934950447724
    ],
    [
      121.13031971164274, 14.297555057761807
    ],
    [
      121.13029548594294, 14.29728832470432
    ],
    [
      121.13006130643716, 14.29695692913416
    ],
    [
      121.13031163661483, 14.296334551794466
    ],
    [
      121.13096621082417, 14.295672797341501
    ],
    [
      121.131628374202, 14.295624300534081
    ],
    [
      121.13153147140278, 14.294913011969667
    ],
    [
      121.13214518338098, 14.294104729790412
    ],
    [
      121.13287194698205, 14.29355509827852
    ],
    [
      121.13355025918351, 14.293749085508207
    ],
    [
      121.13380866500518, 14.294719024123312
    ],
    [
      121.13405091953886, 14.294670527315892
    ],
    [
      121.1341155197621, 14.294411877265198
    ],
    [
      121.13461618011746, 14.294056232982992
    ],
    [
      121.13493918616238, 14.294298717636767
    ],
    [
      121.13508453789686, 14.29400773617557
    ],
    [
      121.135488295453, 14.293926907957644
    ],
    [
      121.135488295453, 14.293215619393232
    ],
    [
      121.13592435435295, 14.292795312906687
    ],
    [
      121.13624736039786, 14.292762981496184
    ],
    [
      121.13671571940942, 14.292536662239323
    ],
    [
      121.13704821441672, 14.292262012948399
    ],
    [
      121.1375650248279, 14.2913567371543
    ],
    [
      121.13834023859638, 14.290677780000392
    ],
    [
      121.1386955459851, 14.290483792154037
    ],
    [
      121.138905499175, 14.29058078576888
    ],
    [
      121.13909930354124, 14.290370632525608
    ],
    [
      121.14802690271861, 14.299143490791963
    ],
    [
      121.15357517620836, 14.302475617103312
    ],
    [
      121.1556835218277, 14.306529703691748
    ],
    [
      121.14708369791848, 14.314138059193025
    ],
    [
      121.1390972856276, 14.31875370228634
    ],
    [
      121.13079618784815, 14.31660482565634
    ],
    [
      121.1249281570855, 14.312736854826676
    ],
    [
      121.12480851526826, 14.31162137882676
    ],
    [
      121.12508316966188, 14.310753225974475
    ],
    [
      121.12550237778055, 14.31052171876798
    ],
    [
      121.12495307009617, 14.3096680338052
    ],
    [
      121.12485232141182, 14.307305122200628
    ],
    [
      121.12539020866461, 14.305151531611319
    ],
    [
      121.12661966272992, 14.302690286271405
    ],
    [
      121.12746491203342, 14.301575033491105
    ],
    [
      121.12869436902997, 14.299998298218146
    ],
    [
      121.12990726525756, 14.299122880479345
    ],
    [
      121.13021619290141, 14.29876378460631
    ],
    [
      121.13042761006444, 14.298432661942568
    ]
],
[
  [
    121.4062006835714, 14.301162523294057
  ],
  [
    121.40609021920784, 14.30075751849121
  ],
  [
    121.4046173760096, 14.29806975589758
  ],
  [
    121.40444064351597, 14.295227345781138
  ],
  [
    121.40440382299786, 14.29327595657779
  ],
  [
    121.40543481436032, 14.29088274305937
  ],
  [
    121.40731268887619, 14.288452710028732
  ],
  [
    121.40963241522789, 14.286317227477815
  ],
  [
    121.41158393358924, 14.28407128919926
  ],
  [
    121.41298313575128, 14.281383526605628
  ],
  [
    121.41313041782371, 14.279726686477492
  ],
  [
    121.41552378802086, 14.28086806186158
  ],
  [
    121.41434551458593, 14.283077184841472
  ],
  [
    121.41206260594312, 14.286280409370109
  ],
  [
    121.40930102494642, 14.288968171963738
  ],
  [
    121.4071654039945, 14.29088274376164
  ],
  [
    121.40609759211395, 14.292834132262717
  ],
  [
    121.4057293813144, 14.296442361594202
  ],
  [
    121.40639216187729, 14.298504207929707
  ],
  [
    121.4082332158751, 14.301376063870908
  ],
  [
    121.40930102494644, 14.300639690480624
  ],
  [
    121.41051612170864, 14.301891525103658
  ],
  [
    121.41099479406253, 14.303327451669738
  ],
  [
    121.41147346922565, 14.303290634264291
  ],
  [
    121.41143664870754, 14.302186074178866
  ],
  [
    121.41239399622455, 14.301228789333306
  ],
  [
    121.4138668394228, 14.300639689778368
  ],
  [
    121.41460326102192, 14.301081514093442
  ],
  [
    121.41405094482258, 14.2993878558576
  ],
  [
    121.41423505022236, 14.298062382912375
  ],
  [
    121.4132040588599, 14.297473284761958
  ],
  [
    121.41342498758702, 14.296847367099312
  ],
  [
    121.41209942927044, 14.29581644463382
  ],
  [
    121.41147347203487, 14.294785522168327
  ],
  [
    121.41165757743465, 14.293165497338855
  ],
  [
    121.41254128391544, 14.29198730244254
  ],
  [
    121.41401412711369, 14.292281851517748
  ],
  [
    121.41582006180175, 14.290153033434505
  ],
  [
    121.41721926396377, 14.291036682064654
  ],
  [
    121.41788204452666, 14.29376126417051
  ],
  [
    121.42090137195939, 14.299504976052912
  ],
  [
    121.42149050586761, 14.304291404494274
  ],
  [
    121.417808397872, 14.3082678205209
  ],
  [
    121.41537820996591, 14.320417980056053
  ],
  [
    121.40138619958257, 14.323068923137455
  ],
  [
    121.39593667862538, 14.322111638291897
  ],
  [
    121.38665776760013, 14.319239779541654
  ],
  [
    121.38290201856829, 14.317693397950197
  ],
  [
    121.37921991057267, 14.313864255758915
  ],
  [
    121.38363844016742, 14.306795072335813
  ],
  [
    121.38842518056171, 14.297811310794465
  ],
  [
    121.39932421685764, 14.293982168603184
  ],
  [
    121.40072341340121, 14.297811310794465
  ],
  [
    121.40182804579989, 14.298694959424614
  ],
  [
    121.40123891189167, 14.301198627266151
  ],
  [
    121.40315360692568, 14.301272266290605
  ],
  [
    121.4062006835714, 14.301162523294057
  ]
],
[
  [
    121.12831237134259,
    14.539405902057785
  ],
  [
    121.13185980161211,
    14.533393878203464
  ],
  [
    121.13501307881012,
    14.529451567725857
  ],
  [
    121.13846197081176,
    14.525115024696616
  ],
  [
    121.14102400336654,
    14.51782174880917
  ],
  [
    121.1420094010813,
    14.515062132226781
  ],
  [
    121.14220647761705,
    14.517920308826918
  ],
  [
    121.14102400336654,
    14.523538102009445
  ],
  [
    121.14013714391966,
    14.526396274849903
  ],
  [
    121.13826488675802,
    14.527480412487053
  ],
  [
    121.13629409132851,
    14.528860220778249
  ],
  [
    121.13639263711437,
    14.531225606688844
  ],
  [
    121.13708241250751,
    14.53477368649466
  ],
  [
    121.1403342279734,
    14.534478012080935
  ],
  [
    121.1412210799023,
    14.53201406803243
  ],
  [
    121.14220647761705,
    14.52984579839765
  ],
  [
    121.14378311997504,
    14.529648678362154
  ],
  [
    121.14378311997504,
    14.528071757554823
  ],
  [
    121.14299479879604,
    14.527184736193488
  ],
  [
    121.14378311997504,
    14.524129447077215
  ],
  [
    121.14299479879602,
    14.522749636906184
  ],
  [
    121.14440038435977,
    14.519673884799154
  ],
  [
    121.14538578207453,
    14.517407057026466
  ],
  [
    121.14499162148502,
    14.515140229253777
  ],
  [
    121.14400622377026,
    14.513267630273042
  ],
  [
    121.14459746089553,
    14.51218349639557
  ],
  [
    121.14607555746761,
    14.515468763690619
  ],
  [
    121.14637117978923,
    14.517834149601216
  ],
  [
    121.15050984718401,
    14.520002419235995
  ],
  [
    121.1529733414709,
    14.520495208045697
  ],
  [
    121.15573245807941,
    14.5181298221351
  ],
  [
    121.1546485145788,
    14.516552897568088
  ],
  [
    121.15809740658044,
    14.51753847518749
  ],
  [
    121.15957550315257,
    14.516651455705997
  ],
  [
    121.16134922204633,
    14.51487741298333
  ],
  [
    121.16578351176273,
    14.510639431851677
  ],
  [
    121.167951383728,
    14.501375004485107
  ],
  [
    121.16686744774536,
    14.49851682788497
  ],
  [
    121.16696598601324,
    14.496348556370348
  ],
  [
    121.16997238284966,
    14.46642736573033
  ],
  [
    121.14585318637624,
    14.436010656834851
  ],
  [
    121.12455530619874,
    14.434986704061469
  ],
  [
    121.10498028915615,
    14.441979050320805
  ],
  [
    121.09449368431281,
    14.462256851805511
  ],
  [
    121.09099814936503,
    14.483233890583518
  ],
  [
    121.10532986398597,
    14.503162080089995
  ],
  [
    121.10620552178446,
    14.512473084319108
  ],
  [
    121.10673365297883,
    14.525150499236972
  ],
  [
    121.10451559938805,
    14.527271857487076
  ],
  [
    121.10477967002188,
    14.532289999685151
  ],
  [
    121.10108276173446,
    14.534006736917103
  ],
  [
    121.09698976260621,
    14.537968428921511
  ],
  [
    121.09580146993717,
    14.539288992922982
  ],
  [
    121.09448114698785,
    14.542854511696907
  ],
  [
    121.09619757085127,
    14.545231530929595
  ],
  [
    121.09698976260621,
    14.54272245731178
  ],
  [
    121.09831008555554,
    14.539817215501039
  ],
  [
    121.10200699384295,
    14.537308146920777
  ],
  [
    121.10530780121626,
    14.535327300918572
  ],
  [
    121.10742031592054,
    14.533478509301494
  ],
  [
    121.1071562452867,
    14.52925270348928
  ],
  [
    121.10860860858958,
    14.527932139487811
  ],
  [
    121.11058909301356,
    14.528328307680741
  ],
  [
    121.11256957743755,
    14.526875689294146
  ],
  [
    121.11573834445731,
    14.529384762911958
  ],
  [
    121.11716543389416,
    14.528552009320382
  ],
  [
    121.11691021689676,
    14.530696223887121
  ],
  [
    121.11650186814317,
    14.532636226800836
  ],
  [
    121.12041605622164,
    14.535952717764985
  ],
  [
    121.12358074543181,
    14.536616403689811
  ],
  [
    121.12531621789876,
    14.53625903427077
  ],
  [
    121.12618395802653,
    14.53283850174139
  ],
  [
    121.12865574881938,
    14.531314560989399
  ],
  [
    121.12967661680904,
    14.529936137200245
  ],
  [
    121.13090165528115,
    14.528915082830132
  ],
  [
    121.13166730627339,
    14.528098240113042
  ],
  [
    121.13376008487329,
    14.525137182829214
  ],
  [
    121.13467886372739,
    14.522941916322972
  ],
  [
    121.1333006934991,
    14.522380335250906
  ],
  [
    121.1342705188681,
    14.520848753695736
  ],
  [
    121.13631225484738,
    14.521614544473321
  ],
  [
    121.1375372972138,
    14.519623487672595
  ],
  [
    121.13774147159059,
    14.5178876944644
  ],
  [
    121.13850712258281,
    14.515998745437695
  ],
  [
    121.1382519055854,
    14.512016631836248
  ],
  [
    121.13789460334675,
    14.509106628439433
  ],
  [
    121.1393748627106,
    14.508647153193879
  ],
  [
    121.14136555217495,
    14.50655399251415
  ],
  [
    121.14442815614386,
    14.503031354158251
  ],
  [
    121.14815432586376,
    14.501397666776569
  ],
  [
    121.15152318945071,
    14.499304506096838
  ],
  [
    121.1533607510532,
    14.50001924493492
  ],
  [
    121.15330970843257,
    14.502316617267676
  ],
  [
    121.1512679724533,
    14.501806090082619
  ],
  [
    121.14825641110504,
    14.503184511924267
  ],
  [
    121.14274372240328,
    14.506502937653382
  ],
  [
    121.13947694405758,
    14.511199790092911
  ],
  [
    121.13911964181891,
    14.516662429415017
  ],
  [
    121.13789459945248,
    14.52064454204271
  ],
  [
    121.13569973561134,
    14.523962968745579
  ],
  [
    121.12692026856378,
    14.536624041571725
  ],
  [
    121.12441914510458,
    14.539534047889806
  ],
  [
    121.12831237134259,
    14.539405902057785
  ]
],
[
  [
    121.05187076667245,
    14.370665696502076
  ],
  [
    121.05227928710032,
    14.37054311675164
  ],
  [
    121.05264695299198,
    14.371360306774996
  ],
  [
    121.05199332093076,
    14.371401167211364
  ],
  [
    121.05272865894761,
    14.371850621100743
  ],
  [
    121.05272865894761,
    14.372790389315869
  ],
  [
    121.05305547341985,
    14.373403281833387
  ],
  [
    121.05281036178648,
    14.37462906686842
  ],
  [
    121.05338229100883,
    14.374792505496558
  ],
  [
    121.0535048483839,
    14.373607579339225
  ],
  [
    121.0541176290257,
    14.373852737281432
  ],
  [
    121.05428103470342,
    14.374751646618856
  ],
  [
    121.05477126108691,
    14.37605914862996
  ],
  [
    121.05603767378993,
    14.377203215909592
  ],
  [
    121.05681386322622,
    14.377775249549407
  ],
  [
    121.05656875159285,
    14.378919313711705
  ],
  [
    121.05808027592923,
    14.380063380991338
  ],
  [
    121.05747607068352,
    14.37900916945473
  ],
  [
    121.05743383117877,
    14.377657237577301
  ],
  [
    121.0587010356574,
    14.376474297788912
  ],
  [
    121.05963031765266,
    14.375291358000522
  ],
  [
    121.06084546098486,
    14.373946010723245
  ],
  [
    121.06129050355207,
    14.373426701016204
  ],
  [
    121.06874023546018,
    14.375141864528961
  ],
  [
    121.08307043627012,
    14.38025182350035
  ],
  [
    121.10176200254394,
    14.394086103536495
  ],
  [
    121.109986289803,
    14.402810426978442
  ],
  [
    121.11726841606698,
    14.409839578351203
  ],
  [
    121.11116251202316,
    14.41681903520301
  ],
  [
    121.09409087578885,
    14.419934865003706
  ],
  [
    121.07253326555025,
    14.419436332711031
  ],
  [
    121.0585768998686,
    14.402735483077551
  ],
  [
    121.05134949994694,
    14.397625524106163
  ],
  [
    121.05047722114995,
    14.39500822422095
  ],
  [
    121.05209716069649,
    14.391767763129979
  ],
  [
    121.05110027335907,
    14.389150463244768
  ],
  [
    121.05296942998645,
    14.386283900779002
  ],
  [
    121.05446476099257,
    14.38516220490338
  ],
  [
    121.05409092586429,
    14.381423209142545
  ],
  [
    121.05677370012666,
    14.380578270182708
  ],
  [
    121.05614457421518,
    14.379445636794253
  ],
  [
    121.05619490544007,
    14.378287834159002
  ],
  [
    121.05538962312141,
    14.377457235572686
  ],
  [
    121.05518830398171,
    14.377029352616274
  ],
  [
    121.05438302166306,
    14.376148415536365
  ],
  [
    121.05387972093388,
    14.375368156403788
  ],
  [
    121.05274729429323,
    14.375443665104322
  ],
  [
    121.05196717854699,
    14.374940272487231
  ],
  [
    121.0519923451194,
    14.374008996913725
  ],
  [
    121.05224399548399,
    14.373555942790228
  ],
  [
    121.05214333495415,
    14.372599497009784
  ],
  [
    121.05148904439021,
    14.37149203382827
  ],
  [
    121.05187076667245,
    14.370665696502076
  ]
],
[
  [
    121.06031402047901,
    14.369331033007777
  ],
  [
    121.06069214388918,
    14.368632832767092
  ],
  [
    121.06205920135226,
    14.368749199843792
  ],
  [
    121.0640661598003,
    14.368836474596439
  ],
  [
    121.06668393111018,
    14.36938921543637
  ],
  [
    121.0696754205575,
    14.370363049093545
  ],
  [
    121.07086796037706,
    14.370653965675537
  ],
  [
    121.07133334371855,
    14.371293982377873
  ],
  [
    121.07175733223724,
    14.371212734500386
  ],
  [
    121.07139258541038,
    14.370694315335033
  ],
  [
    121.07097527295174,
    14.369774356379565
  ],
  [
    121.07049534330183,
    14.36996636328795
  ],
  [
    121.06968906207582,
    14.370062366742141
  ],
  [
    121.06869080752521,
    14.369678352925375
  ],
  [
    121.06623356859643,
    14.369025529876337
  ],
  [
    121.06525158258746,
    14.367728019844526
  ],
  [
    121.06512675680932,
    14.365456819210943
  ],
  [
    121.06533792702699,
    14.362845525916127
  ],
  [
    121.0748830617989,
    14.364199075862773
  ],
  [
    121.09137390615236,
    14.369627434294939
  ],
  [
    121.10640017446536,
    14.377731644343555
  ],
  [
    121.10613924337122,
    14.383890743027573
  ],
  [
    121.10888538623682,
    14.395135010724196
  ],
  [
    121.10642211070962,
    14.396073576986073
  ],
  [
    121.10440552018342,
    14.393159262050228
  ],
  [
    121.1018231737866,
    14.393367553915441
  ],
  [
    121.08432448779855,
    14.379985873917185
  ],
  [
    121.07291217650156,
    14.375820036612915
  ],
  [
    121.06758087999704,
    14.374237017165978
  ],
  [
    121.06129161453816,
    14.372945608237309
  ],
  [
    121.06199967633731,
    14.37165419930864
  ],
  [
    121.06316589913584,
    14.371612539982113
  ],
  [
    121.06429046862335,
    14.37098766438647
  ],
  [
    121.06587319911026,
    14.370571080656044
  ],
  [
    121.06816399139629,
    14.37202912371254
  ],
  [
    121.07020487652716,
    14.3714042481169
  ],
  [
    121.06737262615285,
    14.370196156252144
  ],
  [
    121.06395726120157,
    14.369612938393889
  ],
  [
    121.06031402047901,
    14.369331033007777
  ]
],
[
  [
    121.30758575958342,
    14.47090943956304
  ],
  [
    121.30553924985703,
    14.471020082420088
  ],
  [
    121.30470958306744,
    14.46991365807028
  ],
  [
    121.30260775884582,
    14.470522192728877
  ],
  [
    121.30393522655316,
    14.470632833475587
  ],
  [
    121.3058711157289,
    14.471462651737944
  ],
  [
    121.3063136021514,
    14.474781924787374
  ],
  [
    121.3058711157289,
    14.477050095970686
  ],
  [
    121.29104773406678,
    14.479871477218566
  ],
  [
    121.27149059638204,
    14.471817557657358
  ],
  [
    121.26622254064367,
    14.466899802602365
  ],
  [
    121.25919846632584,
    14.45337599965079
  ],
  [
    121.23250474477187,
    14.440054805703967
  ],
  [
    121.22214423247361,
    14.43232691734594
  ],
  [
    121.2210906240054,
    14.426004092289478
  ],
  [
    121.22442706198584,
    14.421086343934387
  ],
  [
    121.22688549067655,
    14.41687112723008
  ],
  [
    121.22793909914475,
    14.411250847224204
  ],
  [
    121.2296951177242,
    14.407738168870582
  ],
  [
    121.2293439059699,
    14.401064081338681
  ],
  [
    121.23355835324007,
    14.3945656250445
  ],
  [
    121.23496316006522,
    14.390350415040094
  ],
  [
    121.23268034395034,
    14.387364637099534
  ],
  [
    121.23426076335127,
    14.380836423586933
  ],
  [
    121.23426076335127,
    14.37451359853047
  ],
  [
    121.23513877264101,
    14.369068949762317
  ],
  [
    121.23724598957742,
    14.36625880975938
  ],
  [
    121.23671917864463,
    14.359935984702918
  ],
  [
    121.23817763894888,
    14.353732522883396
  ],
  [
    121.23817763894888,
    14.34670716617615
  ],
  [
    121.24327008211142,
    14.343721394935493
  ],
  [
    121.24607972255643,
    14.346004634525368
  ],
  [
    121.24941614713951,
    14.344423926586277
  ],
  [
    121.25152337747328,
    14.34635590370071
  ],
  [
    121.25485981545371,
    14.344423926586277
  ],
  [
    121.25766944250137,
    14.345302096174683
  ],
  [
    121.26557152610893,
    14.346004634525368
  ],
  [
    121.28207810343528,
    14.343018843185003
  ],
  [
    121.29261421491202,
    14.344072657410933
  ],
  [
    121.31491565890953,
    14.342316318234122
  ],
  [
    121.3208861113618,
    14.343194487822528
  ],
  [
    121.32246651736541,
    14.348814774528304
  ],
  [
    121.3201837146479,
    14.35285435329499
  ],
  [
    121.32193973322735,
    14.356893938761578
  ],
  [
    121.32158850807569,
    14.360933517528263
  ],
  [
    121.32387133758793,
    14.36356802629348
  ],
  [
    121.32545177038627,
    14.365499996708012
  ],
  [
    121.32580296874322,
    14.369012675061635
  ],
  [
    121.32861258239352,
    14.371822821764473
  ],
  [
    121.32896380754518,
    14.376564932181942
  ],
  [
    121.33159783541437,
    14.378321271358754
  ],
  [
    121.33300262884215,
    14.382009587649998
  ],
  [
    121.33444038907388,
    14.386963811385755
  ],
  [
    121.3328599696729,
    14.391179028090063
  ],
  [
    121.33619640765333,
    14.396448045620497
  ],
  [
    121.33602080847486,
    14.399785086036497
  ],
  [
    121.33865483634405,
    14.40470284109149
  ],
  [
    121.33883043552251,
    14.408566781920554
  ],
  [
    121.34076205328044,
    14.412430729449518
  ],
  [
    121.34023524234766,
    14.419280454919043
  ],
  [
    121.3400596431692,
    14.423846937448744
  ],
  [
    121.33775567501229,
    14.430451171525766
  ],
  [
    121.33354122774213,
    14.432207510702577
  ],
  [
    121.3316096099842,
    14.435193281943235
  ],
  [
    121.33002919058322,
    14.437827790708452
  ],
  [
    121.33196080834115,
    14.442569911175774
  ],
  [
    121.3302047897617,
    14.445028785353319
  ],
  [
    121.30758575958342,
    14.47090943956304
  ]
],
[
  [
    121.1392272516905,
    14.276250012842864
  ],
  [
    121.13953296675383,
    14.276107354997325
  ],
  [
    121.13965525246819,
    14.27659646738848
  ],
  [
    121.13967563316142,
    14.277207857488714
  ],
  [
    121.13998134822475,
    14.277961904657062
  ],
  [
    121.14047049263708,
    14.27898088815745
  ],
  [
    121.14062063317269,
    14.279066326903243
  ],
  [
    121.14120516757957,
    14.279215698089768
  ],
  [
    121.14130908470837,
    14.279520934889161
  ],
  [
    121.14107527104471,
    14.279637834191716
  ],
  [
    121.1411791881735,
    14.280040487014638
  ],
  [
    121.14096264671203,
    14.280821591110268
  ],
  [
    121.14114344934521,
    14.281429048299167
  ],
  [
    121.14108559228188,
    14.281913567552873
  ],
  [
    121.14070229047887,
    14.282564414560676
  ],
  [
    121.14162076818651,
    14.282788595038845
  ],
  [
    121.14206915849611,
    14.283012775792876
  ],
  [
    121.1423150501876,
    14.283208029495217
  ],
  [
    121.14298763565199,
    14.283330967568343
  ],
  [
    121.14344618244053,
    14.28368931522252
  ],
  [
    121.14435019560646,
    14.28424615065717
  ],
  [
    121.14459552160147,
    14.28387006490477
  ],
  [
    121.14480573940759,
    14.283327036007911
  ],
  [
    121.1453312852594,
    14.282713939318961
  ],
  [
    121.14594442208652,
    14.282748973549118
  ],
  [
    121.14687288695934,
    14.28215339430936
  ],
  [
    121.14724076878831,
    14.28266138830784
  ],
  [
    121.14787142354318,
    14.282766490998307
  ],
  [
    121.14820426951663,
    14.283379587687255
  ],
  [
    121.14848456037029,
    14.282258496331604
  ],
  [
    121.14829186049194,
    14.280752030448905
  ],
  [
    121.14774879671236,
    14.280051348518679
  ],
  [
    121.14752105964196,
    14.279298114909109
  ],
  [
    121.14853711549009,
    14.279140461875741
  ],
  [
    121.14940275428921,
    14.278876653383263
  ],
  [
    121.15061921784697,
    14.27715356169227
  ],
  [
    121.15141079967708,
    14.277179946629836
  ],
  [
    121.15151634432372,
    14.276124573282779
  ],
  [
    121.15283564737382,
    14.274858124461115
  ],
  [
    121.15349529889892,
    14.274541512255702
  ],
  [
    121.15439242537568,
    14.27488450939868
  ],
  [
    121.15436581816579,
    14.274030534917257
  ],
  [
    121.15451553778878,
    14.273431692774581
  ],
  [
    121.15494598473903,
    14.273506547685477
  ],
  [
    121.15530157116386,
    14.272907704828926
  ],
  [
    121.15591916728589,
    14.272570855945201
  ],
  [
    121.15642447476155,
    14.271878443914622
  ],
  [
    121.15702335610919,
    14.271841016816111
  ],
  [
    121.15887366642879,
    14.270432915146415
  ],
  [
    121.16351150790484,
    14.269936036540633
  ],
  [
    121.17096519389148,
    14.275401713840548
  ],
  [
    121.17394667334098,
    14.292130006568359
  ],
  [
    121.16715553974726,
    14.301570725350842
  ],
  [
    121.15771419658192,
    14.305545763674335
  ],
  [
    121.1556778534032,
    14.302043736372898
  ],
  [
    121.14836066802027,
    14.298629273812171
  ],
  [
    121.13947164405491,
    14.289849225750674
  ],
  [
    121.1400916457942,
    14.28844431969441
  ],
  [
    121.14068067502878,
    14.288063208120327
  ],
  [
    121.14094054075093,
    14.288340379813752
  ],
  [
    121.14139097440497,
    14.287612803292474
  ],
  [
    121.1424304372936,
    14.287318308616019
  ],
  [
    121.14274227668888,
    14.285845832590434
  ],
  [
    121.14378173825573,
    14.284511941750733
  ],
  [
    121.14272495124999,
    14.283749719263398
  ],
  [
    121.14208394834229,
    14.283593809772828
  ],
  [
    121.14163351468824,
    14.283212698198746
  ],
  [
    121.14040348386773,
    14.283004819098261
  ],
  [
    121.14024756417008,
    14.282346535830753
  ],
  [
    121.14052475533114,
    14.281393757886793
  ],
  [
    121.1405940531214,
    14.280250423164546
  ],
  [
    121.14080194517044,
    14.279436230406468
  ],
  [
    121.14005699623823,
    14.27941890610178
  ],
  [
    121.1400743216771,
    14.278864563375759
  ],
  [
    121.13948529244254,
    14.27753067319689
  ],
  [
    121.13939867053516,
    14.276820420319469
  ],
  [
    121.1392272516905,
    14.276250012842864
  ]
],
[
  [
    121.25981078883666, 14.190773475705543
  ],
  [
    121.26024399863759, 14.190475663270904
  ],
  [
    121.26086673662903, 14.189798818236888
  ],
  [
    121.26324938795202, 14.189067825393593
  ],
  [
    121.26433241090507, 14.189446859025756
  ],
  [
    121.26541543385812, 14.189690523651116
  ],
  [
    121.26668798500168, 14.19074640128451
  ],
  [
    121.26739194950802, 14.190908844712345
  ],
  [
    121.2674461018951, 14.191612763134609
  ],
  [
    121.26779808311542, 14.191991796766771
  ],
  [
    121.26747317705579, 14.192776936386561
  ],
  [
    121.26777100795474, 14.193535002618104
  ],
  [
    121.26877280336002, 14.194401364984593
  ],
  [
    121.26920601419381, 14.194211847135728
  ],
  [
    121.26944969270569, 14.193507929229856
  ],
  [
    121.26966629812257, 14.192776936386561
  ],
  [
    121.27009950689066, 14.19242497717543
  ],
  [
    121.27028903714687, 14.192073017964297
  ],
  [
    121.27069517075427, 14.191910574536463
  ],
  [
    121.2719947970585, 14.190340294264102
  ],
  [
    121.27283413943398, 14.189311490018952
  ],
  [
    121.27491895985803, 14.187659988549065
  ],
  [
    121.27592075526331, 14.18692899570577
  ],
  [
    121.27632688887071, 14.187226807107624
  ],
  [
    121.27566401464613, 14.18767617263712
  ],
  [
    121.27373629651338, 14.189118758329876
  ],
  [
    121.27117511764766, 14.191863817844958
  ],
  [
    121.27111293319176, 14.192348825038295
  ],
  [
    121.27051596298449, 14.192535366193516
  ],
  [
    121.2703294096168, 14.192945756640125
  ],
  [
    121.27000605063591, 14.193393455697297
  ],
  [
    121.26994386618003, 14.193716793509923
  ],
  [
    121.26963294390055, 14.19420180046606
  ],
  [
    121.27009310849463, 14.194040131085348
  ],
  [
    121.27192133111839, 14.192659726963663
  ],
  [
    121.27255561332761, 14.19236126092555
  ],
  [
    121.273090399079, 14.192709471461482
  ],
  [
    121.27360031142756, 14.193704357622668
  ],
  [
    121.27471963258253, 14.193306403063314
  ],
  [
    121.27546584605327, 14.193094989659182
  ],
  [
    121.27596332170037, 14.193542688241955
  ],
  [
    121.27670953517111, 14.193443199720715
  ],
  [
    121.27730650632725, 14.193754101646086
  ],
  [
    121.27804028214771, 14.193716793509921
  ],
  [
    121.27851288439207, 14.19381628203116
  ],
  [
    121.27877405891705, 14.194015259548035
  ],
  [
    121.27913472895102, 14.19412718395653
  ],
  [
    121.2795327090892, 14.19400282318638
  ],
  [
    121.28019186470122, 14.19441321339579
  ],
  [
    121.28082614596158, 14.194686807659394
  ],
  [
    121.28134849501156, 14.194860912690162
  ],
  [
    121.2813111858562, 14.195184250502788
  ],
  [
    121.282648897847, 14.196033310822035
  ],
  [
    121.28458346212854, 14.202305587462549
  ],
  [
    121.28305925874753, 14.212446742733112
  ],
  [
    121.27665376767017, 14.218062285697204
  ],
  [
    121.25836331368029, 14.221169114762853
  ],
  [
    121.25578389463826, 14.219527770789092
  ],
  [
    121.25425968678469, 14.202997100741504
  ],
  [
    121.25320446665111, 14.19344213391732
  ],
  [
    121.25431830913159, 14.190042208951366
  ],
  [
    121.25528524023598, 14.189765648932399
  ],
  [
    121.25573500089232, 14.190016602458686
  ],
  [
    121.25640387711331, 14.189924349845699
  ],
  [
    121.2569804942418, 14.190235702799438
  ],
  [
    121.25784541993454, 14.190131918334894
  ],
  [
    121.25817985804503, 14.19073156097915
  ],
  [
    121.25860655436817, 14.190685434232762
  ],
  [
    121.25941381834807, 14.190823813812084
  ],
  [
    121.25981078883666, 14.190773475705543
  ]
]
];
